
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator.ts";

@Component
export default class Convenios extends Mixins(FormValidator) {
  private aPreguntas: Array<any> = [];

  private mounted() {
    this.getPreguntas();
  }
  private getPreguntas() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios("listado/preguntas")
      .then(res => {
        this.aPreguntas = res.data;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
      });
  }
}
